export default {
  /*
   * 改行コード置換
   * 引数の文字列に含まれる改行コードをbrタグに置換する。
   */
  nl2br: function(str) {
    if (str == null) {
      return;
    }
    return str.replace(/\n/g, "<br>");
  },
  /*
   * 改行タグ削除
   * 引数の文字列に含まれる改行コードをbrタグに置換する。
   */
  delBrTag: function(str) {
    if (str == null) {
      return;
    }
    return str.replace(/(<br>|<br \/>)/gi, '\n');
  },
  /*
   * 文字種チェック
   */
  isString: function(v) {
    return typeof v === "string";
  },
  /*
   * 画面表示用メッセージ文字列生成
   * 引数のメッセージリストを改行コードを挿入し連結する。
   */
  createMsgViewString: function(msgArry) {
    let retVal = "";
    if (msgArry.length == 0) {
      return retVal;
    }
    msgArry.forEach(function(value) {
      retVal = retVal.concat(value);
      retVal = retVal.concat("<br/>");
    });
    return retVal;
  },
  createMsgViewStringForErrList: function(msgArry) {
    let retVal = "";
    if (msgArry == null || msgArry.length == 0) {
      return retVal;
    }
    msgArry.forEach(function(value) {
      retVal = retVal.concat(value.message);
      retVal = retVal.concat("<br/>");
    });
    return retVal;
  },
  /*
   * メッセージ文字列生成
   * 引数のメッセージをパラメータで置換する。
   */
  replaceMsgStringByParam: function(msg, param) {
    let retVal = msg;
    if (msg == "") {
      return retVal;
    }
    for (let i = 0; i < param.length; i++) {
      let index = "{" + i + "}";
      retVal = msg.replace(index, param[i]);
    }
    return retVal;
  },
  /**
   * メールアドレスチェック
   * 引数のメールアドレスの整合性をチェックする。
   * @param {メールアドレス} mail
   * @returns チェック結果(True:OK False:NG)
   */
  chkMailAddress: function(mail) {
    let retVal = false;
    let reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
    if (reg.test(mail)) {
      retVal = true;
    }
    return retVal;
  },
  /**
   * null, Empty, undefinedチェック
   * @param {チェック対象} obj
   * @returns チェック結果(True:null,Emptyまたはundefinedである False:null,Emptyかつundefinedでない)
   */
  isNullOrEmptyOrUunDef(obj) {
    let retVal = false;
    if (obj == null) {
      retVal = true;
    } else if (obj == "") {
      retVal = true;
    } else if (obj == "undefined") {
      retVal = true;
    }
    return retVal;
  },
  isEmptyArry(obj) {
    let retVal = false;
    if (!Array.isArray(obj)) {
      retVal = true;
    } else if (obj.length === 0) {
      retVal = true;
    }
    return retVal;
  },
  /**
   * 画面表示用プランの生成
   * @param {*} planMstrList プランマスタ情報 
   * @param {*} selectedPlanIdList 選択済みプランID
   * @returns 画面表示用プラン名(html)
   */
  getPlanInfoForDisp(planMstrList, selectedPlanIdList) {
    let retVal = "";
    if (planMstrList == null || selectedPlanIdList == null) {
      return retVal;
    }

    let searchArry = [];
    let planNmBase = "";
    let planNmOption = "";
    let selectedPlanId = "";
    for (selectedPlanId of selectedPlanIdList) {
      if (this.isNullOrEmptyOrUunDef(selectedPlanId)) {
        continue;
      }
      searchArry = planMstrList.find((v) => v.planCd === selectedPlanId);
      if (searchArry == null) {
        continue;
      }

      if (searchArry.planTyp == "1") {
        if (planNmBase != "") {
          planNmBase = planNmBase + ", ";
        }
        planNmBase = planNmBase + searchArry.name;
      } else if (searchArry.planTyp == "2") {
        if (planNmOption != "") {
          planNmOption = planNmOption + ", ";
        }
        planNmOption = planNmOption + searchArry.name;
      }
    }
    if (planNmBase != "" || planNmOption != "") {
      retVal = planNmBase + "<br/>" + planNmOption;
    }
    return retVal;
  },
  /**
   * 文字列削除
   * @param {*} targetChars 対象文字列 
   * @param {*} removeChar 削除文字列
   * @returns 指定した削除文字列を、対象文字列から削除した文字列
   */
  removeChar(targetChars, removeChar) {
    let retVal = targetChars;
    if (this.isNullOrEmptyOrUunDef(targetChars) || this.isNullOrEmptyOrUunDef(removeChar)) {
      return retVal;
    }
    return targetChars.replaceAll(removeChar, "");
  }
};
